import Store from 'store/store';

export const IMAGE_REGION_ROOT_DYNAMIC = '%IMAGE_REGION_ROOT_DYNAMIC%';

export function useDynamicAssetFolder(path) {
	if (!path || typeof path !== 'string') {
		return path;
	}
	const store = Store.get();
	const imageRegionRoot = store?.appData?.urls?.roots?.imageRegion;
	let newRoot = imageRegionRoot;

	// assetUpdateDateTime soon to be legacy, dynamicAssetUpdate is the new way
	const assetUpdateDateTime = store?.appData?.options?.useAssetUpdateDateTime;
	const dynamicAssetUpdate = store?.appData?.options?.dynamicAssetUpdate;

	const now = Date.now();
	if (dynamicAssetUpdate?.useDynamicUpdates) {
		const dynamicDateTimes = Object.values(dynamicAssetUpdate?.dateTimesForUpdates).sort((a, b) => a - b);

		let updates = dynamicDateTimes.filter(datetime => now > datetime);
		if (updates.length > 0) {
			// Each update should probably have a unique ID so that the array changing (e.g. removing old updates) doesn't affect which folder is used
			newRoot += `/updates${updates.length}`;
		}
	} else if (assetUpdateDateTime && (now > assetUpdateDateTime)) {
		newRoot += '/updates';
	}

	return path.replace(/%IMAGE_REGION_ROOT_DYNAMIC%/g, newRoot);
}
